import { ApolloCache } from '@apollo/client';
import {
  DashboardListItemViewFragment,
  DashboardUseCase,
  DashboardViewFragment,
  ListDashboardsDocument,
  ListDashboardsQuery,
  UserInfoViewFragment,
} from 'generated/graphql';
import { User } from 'v2/core/entities/user';

export const createCachedDashboardListItem = (
  cache: ApolloCache<unknown>,
  dashboard: DashboardViewFragment,
  user: User,
) => {
  const createdBy: UserInfoViewFragment = {
    __typename: 'UserInfo',
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
  };

  const dashboardListItem: DashboardListItemViewFragment = {
    __typename: 'DashboardListItem',
    id: dashboard.id,
    title: dashboard.title,
    viewToken: dashboard.viewToken,
    editToken: dashboard.editToken,
    scope: dashboard.scope,
    recency: dashboard.createdAt,
    analysisIDs: dashboard.widgets
      ?.filter(({ analysis }) => !!analysis)
      ?.map((a) => a.id),
    shortMetadata: dashboard.shortMetadata,
    createdAt: dashboard.createdAt,
    tenantID: user.tenant.id,
    createdBy,
    version: dashboard.version,
  };

  cache.updateQuery(
    {
      query: ListDashboardsDocument,
      variables: {
        tenantID: user.tenant.id,
        userID: user.id,
        filter: {
          editableBy: user.id,
          useCase: DashboardUseCase.Default,
        },
      },
    },
    (data: ListDashboardsQuery | null) => {
      if (
        !data ||
        !!data.listDashboards?.dashboards?.find((d) => d.id === dashboard.id)
      ) {
        return data;
      }
      return {
        ...data,
        listDashboards: {
          ...data.listDashboards,
          dashboards: [
            dashboardListItem,
            ...(data.listDashboards?.dashboards ?? []),
          ],
        },
      };
    },
  );
};
